<template>
  <div class="fruit-detail" v-loading="loading">
    <div class="body-content" v-if="!loading">
      <h2>“{{info.fruitName}}”成果简介</h2>
      <h3>【{{info.fruitName}}】
        <img v-if="info.fruitImagesList && info.fruitImagesList.length>0" src="../../assets/images/image.png" alt="图片" height="32" @click="currentMedia='image'">
        <img v-if="info.vrUrl" src="../../assets/images/360@2x.png" alt="VR" height="32" @click="currentMedia='vr'">
        <img v-if="info.mp4Url" src="../../assets/images/video@2x.png" alt="视频" height="32" @click="currentMedia='video'">
      </h3>
      <div class="content" v-html="info.description"></div>
      <div>
        <div class="content image-content" v-if="info.fruitImagesList && info.fruitImagesList.length>0 && currentMedia == 'image'" style="height: 650px;overflow: hidden;">
          <div class="left-big-content">
            <img :src="fileUrl + bigImage.url" width="100%">
          </div>
          <div class="right-small-scroll">
            <ul>
              <li class="prev" @click="scrollImage(-1)"><i class="glyphicon glyphicon-menu-up"></i></li>
              <li style="height: 570px; overflow: hidden;">
                <ul class="small-scroll-bar">
                  <li v-for="image in info.fruitImagesList" :key="image.id">
                    <img :src="fileUrl + image.url" @click="bigImage=image"/>
                  </li>
                </ul>
              </li>
              <li class="next" @click="scrollImage(1)"><i class="glyphicon glyphicon-menu-down"></i></li>
            </ul>
          </div>
        </div>
        <div class="content" v-if="info.vrUrl" v-show="currentMedia == 'vr'" style="height: 650px;overflow: hidden;">
          <iframe :src="info.vrUrl" width="100%" height="800" style="margin-top: -50px;"></iframe>
        </div>
        <div class="content" v-if="info.mp4Url && currentMedia == 'video'" style="height: 650px;overflow: hidden;">
          <video width="100%" autoplay controls loop>
            <source :src="fileUrl + info.mp4Url" type="video/mp4">
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
      <div class="message">
        <table>
          <tr>
            <th width="180">项目名称</th>
            <td width="420">{{info.projectName}}</td>
            <th width="180">项目标号</th>
            <td width="420">{{info.projectNumber}}</td>
          </tr>
          <tr>
            <th>课题名称</th>
            <td>{{info.taskName}}</td>
            <th>成果形式</th>
            <td>{{info.fruitStyle}}</td>
          </tr>
          <tr>
            <th>成果类型</th>
            <td>{{info.fruitType}}</td>
            <th>完成时进展阶段</th>
            <td>{{info.completeStage}}</td>
          </tr>
          <tr>
            <th>本年度进展阶段</th>
            <td>{{info.nowStage}}</td>
            <th>是否已完成</th>
            <td>{{info.isComplete}}</td>
          </tr>
        </table>
      </div>
      <div class="relate-content">
        <h3>【相关成果】</h3>
        <div class="relate-list">
          <ul>
            <li v-for="item in info.relateFruitList" :key="item.id"><a :href="'/fruitDetail?id='+item.id">{{item.fruitName}}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fruitDetail',
  data () {
    return {
      currentMedia: 'image',
      bigImage: {},
      smallImage: 0,
      fileUrl: '',
      id: '',
      info: {},
      loading: true
    }
  },
  created () {
    this.fileUrl = FileUrl;
    this.id = this.$route.query.id;
    this.fetchDetail();
  },
  watch: {
    '$route.query.id': function (val) {
      this.id = val;
      this.loading = false;
      this.fetchDetail();
    }
  },
  methods: {
    fetchDetail () {
      this.fetch(`/dataapi/open/nqi/fruit/info/${this.id}`).then(res => {
        this.info = res.result;
        if (this.info.fruitImagesList && this.info.fruitImagesList.length > 0) {
          this.bigImage = this.info.fruitImagesList[0];
          this.currentMedia = 'image'
        } else if (this.info.vrUrl) {
          this.currentMedia = 'vr'
        } else if (this.info.mp4Url) {
          this.currentMedia = 'video'
        }
        this.loading = false;
      }).catch(err => {
        console.log(err);
      })
    },
    scrollImage (step) {
      const _self = this;
      if ((step < 0 && _self.smallImage === 0) || (step > 0 && _self.smallImage === (this.info.fruitImagesList.length - 1))) return;
      let top = Number($('.small-scroll-bar').css('margin-top').split('px')[0]);
      if (step < 0) {
        top = top + ($('.small-scroll-bar').find('li:eq(' + (_self.smallImage - 1) + ')').height() + 12);
      } else {
        if ($('.small-scroll-bar').height() + top > 570) {
          top = top - ($('.small-scroll-bar').find('li:eq(' + _self.smallImage + ')').height() + 12);
        }
      }
      $('.small-scroll-bar').css('margin-top', top + 'px');
      _self.smallImage = _self.smallImage + step;
    }
  }
}
</script>

<style lang="less" scoped>
.body-content {
  display: flex;
  width: @body-width;
  margin: 0 auto;
  flex-flow: column;
}
.fruit-detail {
  margin-bottom: 50px;
  min-height: 450px;
  h2 {
    font-size: 32px;
    text-align: center;
    font-weight: bold;
    margin: 50px;
    line-height: 50px;
    color: rgba(0, 0, 0, 0.85);
  }
  h3 {
    img { cursor: pointer; }
  }
  .message {
    margin-bottom: 30px;
    table {
      width: 100%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      border-left: 1px solid rgba(0, 0, 0, 0.1);
      th {
        color: #000000;
        background: #F7F9FC;
        font-size: 20px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        padding: 20px 22px;
      }
      td {
        font-size: 20px;
        color: #000000;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        padding: 20px 22px;
      }
    }
  }
  .content {
    margin-bottom: 30px;
    font-size: 20px;
    line-height: 28px;
    &.image-content {
      display: flex;
      .left-big-content {
        flex: 1;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .right-small-scroll {
        width: 200px;
        margin-left: 20px;
        li {
          cursor: pointer;
          &.prev, &.next {
            text-align: center;
            height: 40px;
            line-height: 40px;
          }
          li {
            background: #ccc;
            margin-bottom: 12px;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .relate-content {
    background: url(../../assets/images/relate-back.png) no-repeat;
    padding: 40px;
    h3 {
      font-size: 24px;
      color: #ffffff;
      margin-top: 0;
    }
    .relate-list {
      margin-top: 30px;
      li {
        padding-left: 18px;
        font-size: 20px;
        line-height: 1.5;
        float: left;
        margin-bottom: 12px;
        width: 50%;
        a {
          color: #ffffff;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/project/fruitDetail.vue